enum RelationshipType {
    Other = 0,
    Child = 1,
    Spouse = 2,
    Mother = 3,
    Father = 4,
    Brother = 5,
    Sister = 6,
    Sibling = 7,
    Parent = 8,
    Son = 9,
    Daughter = 10,
    Partner = 11,
    Family= 12
}

export default RelationshipType;
